// Phase 24C — Claim / Primary Order / Primary Sales Return / Sales+Return Combined
import { useAuth } from "@/lib/auth";
import TransactionReportPage from "./TransactionReportPage";

export function ClaimReport() {
  return <TransactionReportPage slug="claims" testidPrefix="claims-report"
    title="Claim Report" subtitle="TA/DA, expense, scheme and damage claims."
    initialDaysBack={60} filterConfig={{ showUser: true }} />;
}

export function PrimaryOrderReport() {
  return <TransactionReportPage slug="primary-orders" testidPrefix="primary-order-report"
    title="Primary Order Report" subtitle="Distributor-to-company primary orders."
    initialDaysBack={30} filterConfig={{ showUser: true }} />;
}

export function PrimarySalesReturnReport() {
  return <TransactionReportPage slug="primary-sales-returns" testidPrefix="primary-sr-report"
    title="Primary Sales Return Report" subtitle="Distributor-to-depot returns."
    initialDaysBack={60} filterConfig={{}} />;
}

export function SalesAndReturnsReport() {
  return <TransactionReportPage slug="sales-and-returns" testidPrefix="sales-and-returns-report"
    title="Sales + Sales Return (Combined)"
    subtitle="Stock movement for each distributor and SKU, grouped by month by default."
    initialDaysBack={90} filterConfig={{}} />;
}

export function UserKmReport() {
  return <TransactionReportPage slug="user-km" testidPrefix="user-km-report"
    title="User Kilometer Report" subtitle="Distance travelled per user, day by day (GPS trail). 'User Total' is each user's sum across the chosen dates."
    initialDaysBack={7} filterConfig={{ showUser: true }} />;
}

export function DeviceAccessReport() {
  return <TransactionReportPage slug="device-access" testidPrefix="device-access-report"
    title="Device Access Report" subtitle="Every device each user has logged in from — current vs previous, logins, blocked attempts and the device-change request outcome."
    initialDaysBack={30} filterConfig={{ showUser: true }} />;
}

export function DistributorQueryReport() {
  const { user } = useAuth();
  // /zones is visibility-scoped and returns nothing for a coordinator (no assigned zones).
  const zoneFilters = user?.role_code !== "SALES_COORDINATOR";
  return <TransactionReportPage slug="distributor-queries" testidPrefix="distributor-query-report"
    title="Distributor Query Report" subtitle="Queries raised by distributors (and the field team on their behalf) — response time, status and age."
    initialDaysBack={30}
    filterConfig={{ showDistributor: true, showZone: zoneFilters, showSubZone: zoneFilters }} />;
}

export function DistributorQueryConversationReport() {
  const { user } = useAuth();
  const zoneFilters = user?.role_code !== "SALES_COORDINATOR";
  return <TransactionReportPage slug="distributor-query-conversations" testidPrefix="distributor-query-conversation-report"
    title="Distributor Query Conversation Report"
    subtitle="Every query in full — the description, each message and reply, status changes and attached file names, one row per entry."
    initialDaysBack={30}
    filterConfig={{ showDistributor: true, showZone: zoneFilters, showSubZone: zoneFilters }} />;
}

export function BeatReport() {
  return <TransactionReportPage slug="beat-report" testidPrefix="beat-report"
    title="Beat Report"
    subtitle="Every beat with its ID, name, created date, owner, location, distributors and active calls (outlets). The date range drives the visit counts."
    initialDaysBack={30} filterConfig={{ showUser: true, showDistributor: true }} />;
}

export function InactiveOutletsReport() {
  return <TransactionReportPage slug="inactive-outlets" testidPrefix="inactive-outlets-report"
    title="Inactive Outlets Report"
    subtitle="Every inactive outlet with its created date and the date it was deactivated, who did it and how. The date range filters on the deactivation date; a * means the date is estimated from the last update."
    initialDaysBack={90} filterConfig={{ showDistributor: true }} />;
}
